import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qin-toggler-wrapper" }
const _hoisted_2 = { class: "g-row g-row--align_center" }
const _hoisted_3 = { class: "g-cell g-cols" }
const _hoisted_4 = { class: "qin-toggler" }
const _hoisted_5 = { class: "qin-toggler__label" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "qin-toggler__slider-round" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "qin-toggler__checkbox",
              onInput: $setup.changeLang,
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.switchableValue) = $event))
            }, null, 544), [
              [_vModelCheckbox, $setup.switchableValue]
            ]),
            _hoisted_6
          ])
        ])
      ])
    ])
  ]))
}